<template>
    <section id="not-found" class="container" data-padding="sm">
        <div class="row">
            <div class="col-12">
                <div class="sectiontitle-element--center">
                    <!-- <p>Please ensure to check the link and try again!</p> -->

                    <router-link
                        :to="{ name: 'Home' }"
                        class="btn--big--round .bg_success"
                        >Return Home</router-link
                    >
                </div>
            </div>
        </div>

        <!-- <div class="row mt-40">
            <div class="col-12">
                <div class="separator-element"></div>
            </div>
        </div> -->
    </section>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
#not-found {
    p {
        color: var(--grey2);
    }

    .sectiontitle-element--center {
        a {
            background: var(--orangeDark) !important;
            border-color: var(--orangeDark) !important;
            color: var(--white) !important;

            &:hover {
                opacity: 0.7;
            }
        }
    }
}
</style>